import apiClient from '../config/api';

export const getCounties = () => apiClient.get('/lookup/counties');
export const getTicketStatuses = () => apiClient.get('/lookup/ticket-statuses');
export const getTicketPriorities = () => apiClient.get('/lookup/ticket-priorities');
export const getTicketPrograms = () => apiClient.get('/lookup/ticket-programs');
export const getTicketIssueTypes = () => apiClient.get('/lookup/ticket-issue-types');
export const getTicketAssignees = () => apiClient.get('/lookup/ticket-assignees');
export const getTicketFilterAssignees = () => apiClient.get('/lookup/ticket-filter-assignees');
